// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Switch } from '@crehana/ui';
import clsx from 'clsx';
import useProfileUITranslations from "../i18n/useProfileUITranslations";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HeaderNightSwitch = function HeaderNightSwitch(_ref) {
  var toggleDarkMode = _ref.toggleDarkMode,
    isDark = _ref.isDark,
    isSupplanting = _ref.isSupplanting;
  var _useProfileUITranslat = useProfileUITranslations(),
    t = _useProfileUITranslat.t;
  return /*#__PURE__*/_jsxs("button", {
    className: clsx('tw-pt-2 tw-px-0.8 tw-mt-2 tw-w-full tw-flex tw-items-center', 'tw-border-solid tw-border-t dark:tw-border-t-neutral-dark-700', isSupplanting ? 'tw-border-t-neutral-dark-300' : 'tw-border-t-neutral-light-300'),
    onClick: toggleDarkMode,
    type: "button",
    children: [/*#__PURE__*/_jsx("p", {
      className: "tw-font-label1 tw-text-neutral-light-700 tw-mr-auto tw-uppercase",
      children: t('PROFILE_NIGHTSWITCH')
    }), /*#__PURE__*/_jsx(Switch, {
      checked: isDark,
      isDark: isDark
    })]
  });
};
export default HeaderNightSwitch;